import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
    data:{}
   
    
}
const mutations={


    getProductGoods(state,value){
        
        
     
        post(urls.admin.product_group_goods.search,value).then((result)=>{

          state.data=result
         

          
       
        
       
           
        });
        
    },
    // getGroupSearch(state,value){
    //
    //
    //
    //     post(urls.admin.product_group_goods.group_search,value).then((result)=>{
    //
    //         state.data=result
    //
    //
    //
    //
    //
    //
    //
    //     });
    //
    // },
    addGroupProduct(state,value){



        post(urls.admin.product_group_goods.group_product_add,value).then((result)=>{

            state.data=result







        });

    },

    getGroupProductSearchIndex(state,value){



        post(urls.admin.product_group_goods.group_product_search_index,value).then((result)=>{

            state.data=result







        });

    },
    groupProductSearchDelete(state,value){



        post(urls.admin.product_group_goods.group_product_search_delete,value).then((result)=>{

            state.data=result







        });

    },
    groupProductSearchEdit(state,value){

        post(urls.admin.product_group_goods.group_product_search_edit,value).then((result)=>{

            state.data=result


        });

    },



}
const  actions={
    getProductGoodsAction(context,value){
       
        context.commit("getProductGoods",value)
       
    },
    // getGroupSearchAction(context,value){
    //
    //     context.commit("getGroupSearch",value)
    //
    // },
    addGroupProductAction(context,value){

        context.commit("addGroupProduct",value)

    },

    getGroupProductSearchIndexAction(context,value){

        context.commit("getGroupProductSearchIndex",value)

    },
    groupProductSearchDeleteAction(context,value){

        context.commit("groupProductSearchDelete",value)

    },

    groupProductSearchEditAction(context,value){

        context.commit("groupProductSearchEdit",value)

    },
    
   

}

export default {state,mutations,actions}